import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';

import {LanguageDropdownModule} from 'shared/language-dropdown/language-dropdown.module';
import {ConstructsDetailsRoutingModule} from './constructs-details-routing.module';
import {ConstructsDetailsComponent} from './constructs-details.component';
import {ConstructsQuestionsModule} from './constructs-questions/constructs-questions.module';
import {ConstructsDetailsRepository} from './repositories/constructs-details.repository';
import {ConstructsDetailsService} from './services/constructs-details.service';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ConstructsDetailsRoutingModule,
    ConstructsQuestionsModule,
    LanguageDropdownModule,
  ],
  declarations: [
    ConstructsDetailsComponent,
  ],
  providers: [
    ConstructsDetailsService,
    ConstructsDetailsRepository,
  ],
})
export class ConstructsDetailsModule { }



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/constructs/constructs-details/constructs-details.module.ts